import { render, staticRenderFns } from "./ModalLightTable.vue?vue&type=template&id=a8ca8782&scoped=true"
import script from "./ModalLightTable.vue?vue&type=script&lang=js"
export * from "./ModalLightTable.vue?vue&type=script&lang=js"
import style0 from "./ModalLightTable.vue?vue&type=style&index=0&id=a8ca8782&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8ca8782",
  null
  
)

export default component.exports